var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 532,
    viewBox: "0 0 532 532",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.006 266L58.6758 146.299L265.999 26.6001L473.329 146.302L266.006 266Z",
    fill: "#FFF7E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.1 207.743L159.582 204.557L366.905 84.8584L372.422 88.043L165.1 207.743Z",
    fill: "#F5B500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M179.899 216.286L144.785 196.012L352.108 76.3145L387.222 96.5879L179.899 216.286Z",
    fill: "#FFF7DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.003 505.4L58.6719 385.697V146.301L266.003 266.002V505.4Z",
    fill: "#FFEEBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M179.905 216.312V241.482L175.465 243.815L171.093 236.395L166.654 238.728L162.281 231.306L157.907 233.678L153.535 226.258L149.162 228.629L144.789 221.207V196.038L179.905 216.312Z",
    fill: "#FFF7DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M473.332 385.697L266.004 505.4V266.002L473.332 146.301V385.697Z",
    fill: "#FFD04A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M457.03 206.478L405.634 236.152C403.249 237.53 401.309 236.408 401.309 233.654V208.229C401.309 205.476 403.249 202.114 405.634 200.737L457.03 171.064C459.417 169.686 461.358 170.808 461.358 173.56V198.985C461.359 201.739 459.417 205.101 457.03 206.478ZM405.635 203.225C404.438 203.917 403.464 205.602 403.464 206.985V232.409C403.464 233.792 404.438 234.354 405.635 233.661L457.031 203.988C458.229 203.298 459.203 201.611 459.203 200.23V174.805C459.203 173.423 458.229 172.861 457.031 173.553L405.635 203.225Z",
    fill: "#F5B500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M409.599 228.183L406.879 229.753V205.699L409.599 204.129V228.183Z",
    fill: "#F5B500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M442.933 208.938L440.215 210.507V186.454L442.933 184.883V208.938Z",
    fill: "#F5B500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M414.889 225.13L410.961 227.399V203.345L414.889 201.075V225.13Z",
    fill: "#F5B500"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M438.999 211.208L435.07 213.476V189.422L438.999 187.154V211.208Z",
    fill: "#F5B500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M452.485 203.421L449.766 204.992V180.939L452.485 179.369V203.421Z",
    fill: "#F5B500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M448.553 205.693L444.625 207.962V183.908L448.553 181.64V205.693Z",
    fill: "#F5B500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M430.151 216.317L424.258 219.721V195.667L430.151 192.264V216.317Z",
    fill: "#F5B500"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M418.664 222.948L416.699 224.083V200.028L418.664 198.895V222.948Z",
    fill: "#F5B500"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M455.788 201.516L453.824 202.65V178.597L455.788 177.462V201.516Z",
    fill: "#F5B500"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M422.446 220.768L420.48 221.902V197.847L422.446 196.713V220.768Z",
    fill: "#F5B500"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M433.802 214.209L431.836 215.342V191.29L433.802 190.154V214.209Z",
    fill: "#F5B500"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M297.466 459.481C297.382 458.552 296.658 458.204 295.787 458.708C295.252 459.016 294.775 459.579 294.466 460.205C294.28 460.583 293.918 460.791 293.732 460.628C293.423 460.359 292.946 460.346 292.412 460.656C291.877 460.964 291.4 461.527 291.091 462.154C290.905 462.531 290.543 462.739 290.359 462.576C290.049 462.307 289.574 462.296 289.038 462.604C288.503 462.913 288.027 463.476 287.718 464.102C287.531 464.48 287.17 464.686 286.985 464.526C286.675 464.255 286.2 464.245 285.664 464.553C284.793 465.056 284.071 466.239 283.984 467.266C284.077 463.005 287.059 457.902 290.726 455.785C294.392 453.668 297.375 455.327 297.466 459.481Z",
    fill: "#F5B500"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M292.413 472.211C291.058 472.992 289.957 472.356 289.957 470.792V460.127L291.498 459.236V469.903C291.498 470.484 291.908 470.722 292.413 470.43C292.916 470.139 293.327 469.427 293.327 468.846L294.868 467.957C294.868 469.521 293.766 471.429 292.413 472.211Z",
    fill: "#F5B500"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.203 472.195L283.247 480.83C281.627 481.766 280.309 481.005 280.309 479.133V461.865C280.309 459.993 281.627 457.71 283.247 456.774L298.203 448.14C299.822 447.204 301.141 447.964 301.141 449.836V467.105C301.141 468.975 299.822 471.259 298.203 472.195ZM283.247 458.465C282.433 458.933 281.773 460.08 281.773 461.019V478.287C281.773 479.226 282.433 479.608 283.247 479.139L298.203 470.504C299.016 470.035 299.677 468.89 299.677 467.951V450.682C299.677 449.742 299.015 449.361 298.203 449.83L283.247 458.465Z",
    fill: "#F5B500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M314.691 445.492C314.475 445.385 314.129 445.595 313.919 445.954L312.525 448.361L310.352 447.097C312.349 443.918 314.498 445.354 314.691 445.492Z",
    fill: "#F5B500"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M318.256 442.515L316.077 446.292L314.705 445.5C314.705 445.5 314.697 445.496 314.691 445.491C314.498 445.353 312.349 443.917 310.352 447.097L311.739 444.695C313.157 442.24 315.468 440.906 316.886 441.724L318.256 442.515Z",
    fill: "#F5B500"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M319.286 445.358L314.953 447.86L319.286 440.355V445.358Z",
    fill: "#F5B500"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M309.863 455.035C309.798 455.405 309.977 455.643 310.264 455.567L312.162 455.065L311.361 458.96C308.84 459.433 309.774 455.405 309.863 455.035Z",
    fill: "#F5B500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M307.394 453.353L310.373 452.556L309.872 455.008C309.872 455.008 309.869 455.021 309.866 455.035C309.776 455.406 308.842 459.433 311.362 458.96L309.467 459.469C307.53 459.988 306.376 458.343 306.893 455.809L307.394 453.353Z",
    fill: "#F5B500"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M309.46 449.417L311.625 452.499L305.707 454.085L309.46 449.417Z",
    fill: "#F5B500"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M317.35 452.16C317.633 451.898 317.799 451.45 317.723 451.167L317.219 449.263L320.194 446.631C320.716 449.339 317.633 451.93 317.35 452.16Z",
    fill: "#F5B500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M316.251 456.819L315.453 453.841L317.328 452.18C317.328 452.18 317.337 452.171 317.347 452.16C317.631 451.93 320.715 449.339 320.191 446.631L320.7 448.526C321.219 450.463 320.062 453.442 318.125 455.159L316.251 456.819Z",
    fill: "#F5B500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M313.16 457.915L315.326 452.33L316.913 458.249L313.16 457.915Z",
    fill: "#F5B500"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M320.741 459.182L305.785 467.816C304.165 468.752 302.848 467.991 302.848 466.12V448.852C302.848 446.979 304.165 444.696 305.785 443.762L320.741 435.126C322.361 434.191 323.68 434.952 323.68 436.823V454.091C323.68 455.965 322.361 458.247 320.741 459.182ZM305.785 445.452C304.972 445.921 304.312 447.067 304.312 448.006V465.276C304.312 466.214 304.974 466.596 305.785 466.127L320.741 457.492C321.555 457.024 322.215 455.877 322.215 454.939V437.669C322.215 436.732 321.554 436.35 320.741 436.818L305.785 445.452Z",
    fill: "#F5B500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M332.693 446.365L330.527 447.616V436.455L332.693 435.204V446.365Z",
    fill: "#F5B500"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M342.224 440.863V443.366L328.77 451.133V448.633L342.224 440.863Z",
    fill: "#F5B500"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M340.461 441.882L338.297 443.132V431.97L340.461 430.72V441.882Z",
    fill: "#F5B500"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M335.16 434.317L328.062 438.415L331.611 432.269L335.16 434.317Z",
    fill: "#F5B500"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M342.926 429.834L335.828 433.931L339.377 427.785L342.926 429.834Z",
    fill: "#F5B500"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M342.972 446.348L328.017 454.982C326.398 455.918 325.078 455.157 325.078 453.286V436.018C325.078 434.147 326.398 431.863 328.017 430.928L342.972 422.292C344.593 421.357 345.91 422.118 345.91 423.989V441.258C345.91 443.13 344.593 445.413 342.972 446.348ZM328.017 432.618C327.203 433.089 326.543 434.233 326.543 435.171V452.441C326.543 453.379 327.204 453.761 328.017 453.293L342.972 444.657C343.785 444.189 344.446 443.042 344.446 442.104V424.835C344.446 423.897 343.785 423.515 342.972 423.984L328.017 432.618Z",
    fill: "#F5B500"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M358.292 425.574C361.218 423.371 363.5 417.705 363.5 414.245L351.945 420.917C351.945 424.38 354.23 427.411 357.154 426.233V433.225L354.142 434.964V436.091L361.303 431.958V430.83L358.293 432.567V425.574H358.292Z",
    fill: "#F5B500"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M365.199 433.513L350.243 442.148C348.623 443.084 347.305 442.323 347.305 440.452V423.183C347.305 421.312 348.623 419.029 350.243 418.092L365.199 409.457C366.818 408.523 368.138 409.284 368.138 411.154V428.424C368.138 430.294 366.818 432.578 365.199 433.513ZM350.243 419.784C349.431 420.253 348.769 421.398 348.769 422.338V439.605C348.769 440.545 349.432 440.927 350.243 440.458L365.199 431.822C366.013 431.354 366.673 430.207 366.673 429.269V412C366.673 411.061 366.012 410.68 365.199 411.149L350.243 419.784Z",
    fill: "#F5B500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.945 179.368L267.913 262.689H264.089L414.885 180.044L267.914 269.314L266.002 270.476L264.087 269.314L115.945 179.368Z",
    fill: "#FFD04A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5131_565399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.817 379.011L157.368 375.203L147.451 392.226L140.898 396.034L150.817 379.011Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.082 367.616L137.634 363.808L157.37 375.203L150.818 379.01L131.082 367.616Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.818 379.011L140.9 396.034L131.082 367.616L150.818 379.011Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4045 289.959L105.957 286.151L105.892 308.829L99.3398 312.637L99.4045 289.959Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6055 289.903L86.1581 286.095L105.956 286.151L99.4036 289.959L79.6055 289.903Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4036 289.959L99.3389 312.637L79.6055 289.903L99.4036 289.959Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.551 330.198L111.103 326.39L125.007 350.472L118.454 354.28L104.551 330.198Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.551 330.198L118.454 354.279L97.4492 350.247L104.551 330.198Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.473 372.299L184.025 368.491L190.99 396.663L184.438 400.471L177.473 372.299Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.477 380.274L170.029 376.466L184.023 368.491L177.471 372.299L163.477 380.274Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.471 372.298L184.436 400.47L163.477 380.273L177.471 372.298Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7344 250.292L104.286 246.484L125.246 266.681L118.694 270.489L97.7344 250.292Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7344 250.292L118.694 270.489L104.699 278.464L97.7344 250.292Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.629 283.301L123.182 279.493C129.462 275.843 138.161 276.359 147.765 281.903L141.212 285.711C131.609 280.167 122.91 279.651 116.629 283.301Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.213 285.711C160.267 296.712 175.679 323.406 175.617 345.335C175.555 367.229 160.042 376.069 140.988 365.068C121.905 354.051 106.493 327.356 106.555 305.462C106.617 283.534 122.13 274.693 141.213 285.711Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.095 363.66L165.543 367.467C171.74 363.866 175.584 356.211 175.614 345.335C175.676 323.406 160.264 296.712 141.211 285.711L147.764 281.903C166.817 292.904 182.229 319.599 182.167 341.527C182.136 352.403 178.292 360.058 172.095 363.66Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.719 300.515L191.272 296.707L184.17 316.756L177.617 320.564L184.719 300.515Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.715 296.483L170.267 292.675L191.273 296.707L184.721 300.515L163.715 296.483Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.721 300.515L177.618 320.564L163.715 296.482L184.721 300.515Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.297 254.745L147.849 250.938L157.639 279.339L151.086 283.147L141.297 254.745Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.299 254.746L151.088 283.147L131.352 271.752L141.299 254.746Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.828 338.125L189.38 334.317L209.114 357.085L202.562 360.893L182.828 338.125Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83 338.125L202.564 360.894L182.766 360.804L182.83 338.125Z",
    fill: "#F5B500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5131_565399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171.095,
    height: 171.095,
    fill: "white",
    transform: "translate(58.8125 237.93)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.9782037e49a99974de4844a6236d4cb7.svg";
export { ForwardRef as ReactComponent };